import { z } from 'zod';

const PathsSchema = z.object({
  auth: z.object({
    signIn: z.string().min(1),
    signUp: z.string().min(1),
    verifyMfa: z.string().min(1),
    callback: z.string().min(1),
    passwordReset: z.string().min(1),
    passwordUpdate: z.string().min(1),
    verificationStatus: z.string().min(1),
  }),
  app: z.object({
    home: z.string().min(1),
    personalAccountSettings: z.string().min(1),
    personalAccountBilling: z.string().min(1),
    personalAccountBillingReturn: z.string().min(1),
    accountHome: z.string().min(1),
    accountSettings: z.string().min(1),
    accountBilling: z.string().min(1),
    accountMembers: z.string().min(1),
    accountReimbursements: z.string().min(1),
    accountAuditions: z.string().min(1),
    accountAuditionsNew: z.string().min(1),
    accountCompetitions: z.string().min(1),
    accountOrganization: z.string().min(1),
    personalMyApplications: z.string().min(1),
    accountBillingReturn: z.string().min(1),
    joinTeam: z.string().min(1),
    dancerProfileSetup: z.string().min(1),
    dancerProfileEdit: z.string().min(1),
    dancerProfileVisibility: z.string().min(1),
    basicProfileSetup: z.string().min(1),
    mergeProfile: z.string().min(1),
    marketplace: z.string().min(1),
    marketplaceSell: z.string().min(1),
    purchases: z.string().min(1),
    sales: z.string().min(1),
    listings: z.string().min(1),
    inbox: z.string().min(1),
    ambassadors: z.string().min(1),
    scholarshipOffers: z.string().min(1),
  }),
});

const pathsConfig = PathsSchema.parse({
  auth: {
    signIn: '/auth/sign-in',
    signUp: '/auth/sign-up',
    verifyMfa: '/auth/verify',
    callback: '/auth/callback',
    passwordReset: '/auth/password-reset',
    passwordUpdate: '/update-password',
    verificationStatus: '/auth/confirm/status',
  },
  app: {
    home: '/home',
    personalAccountSettings: '/home/settings',
    personalAccountBilling: '/home/billing',
    personalAccountBillingReturn: '/home/billing/return',
    accountHome: '/home/[account]',
    accountSettings: `/home/[account]/settings`,
    accountBilling: `/home/[account]/billing`,
    accountMembers: `/home/[account]/members`,
    accountReimbursements: `/home/[account]/reimbursements`,
    accountAuditions: `/home/[account]/auditions`,
    accountAuditionsNew: `/home/[account]/auditions/new`,
    accountCompetitions: `/home/[account]/competitions`,
    accountOrganization: `/home/[account]/organization`,
    personalMyApplications: '/home/auditions/my-applications',
    accountBillingReturn: `/home/[account]/billing/return`,
    joinTeam: '/join',
    dancerProfileSetup: '/home/artist/profile/setup',
    dancerProfileEdit: '/home/artist/profile/edit',
    dancerProfileVisibility: '/home/artist/profile/visibility',
    basicProfileSetup: '/home/profile/setup',
    mergeProfile: '/home/merge-profile',
    marketplace: '/marketplace',
    marketplaceSell: '/marketplace/sell',
    purchases: '/home/purchases',
    sales: '/home/sales',
    listings: '/home/listings',
    inbox: '/home/inbox',
    ambassadors: '/home/ambassadors',
    scholarshipOffers: '/home/offers/scholarships',
  },
} satisfies z.infer<typeof PathsSchema>);

export default pathsConfig;
